export default {
    manage_deleteWorkOrderStatus_title: "Delete Work Order Status",
    manage_deleteWorkOrderStatuses_title: "Delete Work Order Statuses",
    manage_deleteWorkOrderStatuses_description: "Are you sure you want to delete these work order statuses?",
    manage_deleteWorkOrderStatus_description: "Are you sure want to delete this Work Order Status?",
    manage_deleteWorkOrderStatus_successMessage: "Work Order Status deleted",
    manage_deleteWorkOrderStatuses_successMessage: "Work Order Statuses deleted",
}